module.exports = __webpack_public_path__ + "static/media/reception1.fd061482.jpg";